// extracted by mini-css-extract-plugin
module.exports = {"container":"Video_container__3K2zx","video":"Video_video__W4PGa"};